/**
 * This has been placed in a separate module to avoid a circular dependency
 * between tags.actions and projects.actions.
 */

import { tagsApi } from 'api/tags/tags.api';
import { getAllLoadedProjects } from 'redux/selectors/projects';
import type { Thunk } from 'types/redux';
import { notNull } from 'utils/typesafe';
import { fetchProjectId } from './projects.actions';
import { getTagEntities } from './tags.selectors';
import { deleteTag as deleteTagActionCreator, wrapSaving } from './tags.types';
import { showToast } from './toasts.actions';

const deleteTag = (tagId: number): Thunk<Promise<unknown>> => {
  return async (dispatch, getState) => {
    const state = getState();
    const tag = getTagEntities(state)[tagId];

    // Server-side delete of tagSchema
    try {
      const data = await dispatch(
        wrapSaving(tagsApi.delete(tagId), `${tagId.toString()}-deleting`)
      );
      dispatch(
        deleteTagActionCreator.done({
          params: {
            tagId,
          },
        })
      );

      // Update all projects that have this tag marked as required
      getAllLoadedProjects(state)
        .map(project => project.fullProject)
        .filter(notNull)
        .filter(project => project.required_label_ids?.includes(tagId))
        .map(project => void dispatch(fetchProjectId(project.id)));

      return data;
    } catch (err) {
      dispatch(
        showToast({
          message: `Error when deleting tag "${tag?.name}" ${err.message}`,
          type: 'danger',
        })
      );

      dispatch(deleteTagActionCreator.failed(err));
    }
  };
};

export default deleteTag;
